interface MyWindow extends Window {
  _ltk: any;
}

declare const window: MyWindow;

// eslint-disable-next-line no-underscore-dangle
export default window._ltk;
